import { Button, styled } from '@mui/material';

export const BackButton = styled(Button)`
  width: 120px;
  height: 40px;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;
`;
